import { render, staticRenderFns } from "./meiqiKj.vue?vue&type=template&id=89a5d882&scoped=true"
import script from "./meiqiKj.vue?vue&type=script&lang=js"
export * from "./meiqiKj.vue?vue&type=script&lang=js"
import style0 from "./meiqiKj.vue?vue&type=style&index=0&id=89a5d882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a5d882",
  null
  
)

export default component.exports